<template>

  <div>
    <div
      class="buymodal-block__body">
      <div
        class="buymodal-block__loader"
        v-if="loader">
          <v-progress-circular
            :size="70"
            :width="7"
            color="grey"
            indeterminate
          ></v-progress-circular>
          <div><br></div>
          <div>Выполняем операцию. Не закрывайте окно и подождите несколько секунд</div>
      </div>
      <div
        v-if="!moreInfo && !loader && flowType=='default'"
        class="body-form">
        
        <div class="defineDevice">
          <label
          for="number"
          class="body-form__label">
          Введите IMEI или серийный номер:
          <!-- <span
            class="circle"
            @click.prevent="moreInfo = true">
            <img
              src="@/../static/img/icons/question.svg">
          </span> -->
        </label>
        <div class="search">
          <input
            ref="inputImei"
            type="text"
            class="body-form__input"
            autocomplete="off"
            placeholder="333432000123323"
            maxlength="15"
            @beforeinput="handleIdentifierBeforeInput($event, 'primary')"
            @paste="handleIdentifierPaste($event, 'primary')"
            @input="handleIdentifierInput($event, 'primary')"
            :value="number"
            :disabled="false"
            id="number"
            @keyup.enter="defineModel()">
          <button
            type="button"
            class="btn next"
            :class="{ disabled: !primaryIdentifierStatus.valid }"
            :aria-disabled="String(!primaryIdentifierStatus.valid)"
            @click.prevent="defineModel()">
            Определить
          </button>
        </div>
        <div
          class="identifier-status"
          :class="`identifier-status--${primaryIdentifierStatus.state}`"
          aria-live="polite">
          {{ primaryIdentifierStatus.message }}
        </div>
        <div
          class="body-form__size">
          <span
            class="error-mess">
            {{ errorSearch }}
            
          </span>
          <span
            class="length">
            {{ numberLength }} / 15
          </span>
        </div>
          
          <!-- <button
            type="button"
            class="btn next"
            :disabled="deviceList"
            :class="{ hidden: deviceList}"
            @click.prevent="defineModel()">
            Продолжить без IMEI
          </button> -->
          
        </div>
        <div v-if="deviceList" class="chooseModel">
          <multiselect ref="ms_manufacture" :allow-empty="false" :searchable="true"  v-model="valueManufacture" :options="deviceList.manufactures" @select="chooseManufacture" placeholder="Производитель" selectLabel="Выбрать" deselectLabel="" selectedLabel="Выбрано" ></multiselect>
          <multiselect ref="ms_model" :allow-empty="false" :searchable="true" :disabled="deviceList.models.length==0" v-model="valueModel" :options="deviceList.models" @select="chooseModel" placeholder="Модель" selectLabel="Выбрать" deselectLabel="" selectedLabel="Выбрано" ></multiselect>
          <multiselect @keyup.enter="modelId ? startSearch() : false" ref="ms_storage" :allow-empty="false" :searchable="true" :disabled="deviceList.storages.length==0" v-model="valueStorage" :options="deviceList.storages" @select="chooseStorage" placeholder="Объем памяти" selectLabel="Выбрать" deselectLabel="" selectedLabel="Выбрано" ></multiselect>
        </div>
      </div>
      <div
        v-if="!moreInfo && !loader && flowType=='mts'"
        class="body-form">
        
        <div class="defineDevice">
        <div class="body-form__step">
          <label
            for="sourceInfo"
            class="body-form__label"
            >
            Шаг 1. Как клиент узнал об услуге?
          </label>

          <div class="search">
            <multiselect 
              ref="ms_source" 
              :allow-empty="false" 
              :searchable="true"  
              v-model="valueSource" 
              :options="sourceOptions" 
              @select="chooseSource" 
              :placeholder="loadingSourceOptions ? 'Загрузка...' : 'Выберите источник'"
              :loading="loadingSourceOptions"
              :disabled="loadingSourceOptions"
              selectLabel="Выбрать" 
              deselectLabel="" 
              selectedLabel="Выбрано">
            </multiselect>
          </div>
          
          <div v-if="showCustomSourceInput" class="search" style="margin-top: 10px;">
            <input
              ref="inputCustomSource"
              type="text"
              class="body-form__input"
              autocomplete="off"
              placeholder="Укажите источник"
              v-model="customSource"
              id="customSource">
          </div>
        </div>
        </br>
        <div v-if="usesInitialContractType" class="body-form__step"
          :class="{ 'body-form__step__disabled': !sourceSelected }">
          <label class="body-form__label">{{ hasInitialTypeChoice ? 'Шаг 2. Что хочет клиент?' : 'Тип заявки' }}</label>
          <multiselect v-if="hasInitialTypeChoice" v-model="initialType" :options="initialTypeOptions"
            :custom-label="initialTypeLabel" :allow-empty="false" :searchable="false" :disabled="!sourceSelected"
            placeholder="Выберите тип заявки" selectLabel="Выбрать" deselectLabel="" selectedLabel="Выбрано"
            aria-label="Предварительный тип заявки" />
          <div v-else>{{ initialTypeLabel(initialContractType) }}</div>
          <br>
        </div>
        <div class="body-form__step"
        :class="{ 'body-form__step__disabled': !canEnterPhone }">
          <label
            for="phoneNumber"
            class="body-form__label"
            >
            Шаг {{ 2 + initialStepOffset }}. Введите номер телефона:
            <span class="body-form__label__descirption">
              Номер будет использован для подписания договора</br>
            </span>
            <!-- <span
              class="circle"
              @click.prevent="moreInfo = true">
              <img
                src="@/../static/img/icons/question.svg">
            </span> -->
          </label>

          <div class="search">
              <input
                ref="inputPhoneNumber"
                type="text"
                class="body-form__input"
                autocomplete="off"
                placeholder="+7 (999) 999-99-99"
                minlength="18"
                maxlength="18"
                @input="handlePhoneInput($event)"
                @focus="handlePhoneFocus($event)"
                :value="phoneNumber"
                :disabled="!canEnterPhone || phoneNumberEntered"
                id="phoneNumber"
                v-mask="'+7 (###) ###-##-##'"
                @keyup.enter="phoneNumberLength==18 ? confirmPhoneNumber() : false">
                
              <button
                type="button"
                class="btn next"
                :disabled="!canEnterPhone || phoneNumberLength<18 || phoneCheckLoading"
                @click.prevent="phoneNumberLength==18 ? confirmPhoneNumber() : false">
                Продолжить
              </button>
          </div>
        </div>
        </br></br>
        <div class="body-form__step"
        :class="{ 'body-form__step__disabled': !phoneNumberEntered }">
          <label
          for="deviceId"
          class="body-form__label">
          
          Шаг {{ 3 + initialStepOffset }}. Введите IMEI устройства:<br>
          <span class="body-form__label__descirption">
            Для этого откройте окно набора номера,</br>
            введите комбинацию <b style="color:#000;">*#06#</b> и нажмите кнопку вызова.</br>
            Отсканируйте с помощью сканера штрих-кода</br>
          </span>
            
          </label>
          <div class="search">
            <input
              ref="inputImei"
              type="text"
              class="body-form__input"
              autocomplete="off"
              placeholder="333432000123323"
              minlength="15"
              maxlength="15"
              inputmode="numeric"
              @beforeinput="handleIdentifierBeforeInput($event, 'primary', true)"
              @paste="handleIdentifierPaste($event, 'primary', true)"
              @input="handleIdentifierInput($event, 'primary', true)"
              :value="number"
              :disabled="!phoneNumberEntered ? true : false"
              id="deviceId"
              @keyup.enter="defineModel()">
          </div>
          <div
            class="identifier-status"
            :class="`identifier-status--${primaryIdentifierStatus.state}`"
            aria-live="polite">
            {{ primaryIdentifierStatus.message }}
          </div>
          <div
            class="body-form__size">
            <span></span>
            <span
              class="length">
              {{ numberLength }} / 15
            </span>
          </div>
        </div>
        <div class="body-form__step"
        :class="{ 'body-form__step__disabled': !phoneNumberEntered }">
          <label
          for="deviceIdSecond"
          class="body-form__label">
          Шаг {{ 4 + initialStepOffset }}. Введите IMEI2 устройства:
          </label>
          <label class="checkbox-container">На устройстве отсутствует IMEI2
            <input type="checkbox" v-model="withoutDeviceIdSecond" :disabled="!phoneNumberEntered" @change="handleWithoutSecondImeiChange">
            <span class="checkmark"></span>
          </label>
          <div class="search">
            <input
              ref="inputImei"
              type="text"
              class="body-form__input"
              autocomplete="off"
              placeholder="333432000123323"
              minlength="15"
              maxlength="15"
              inputmode="numeric"
              @beforeinput="handleIdentifierBeforeInput($event, 'second', true)"
              @paste="handleIdentifierPaste($event, 'second', true)"
              @input="handleIdentifierInput($event, 'second', true)"
              :value="deviceIdSecond"
              :disabled="!phoneNumberEntered || withoutDeviceIdSecond ? true : false"
              id="deviceIdSecond"
              @keyup.enter="defineModel()">
          </div>
          <div
            class="identifier-status"
            :class="`identifier-status--${secondIdentifierStatus.state}`"
            aria-live="polite">
            {{ secondIdentifierStatus.message }}
          </div>
          <div
            class="body-form__size">
            <span></span>
            <span
              class="length">
              {{ deviceIdSecondLength }} / 15
            </span>
          </div>
        </div>
        </br>
        <button
            type="button"
            class="btn next"
            :disabled="!phoneNumberEntered"
            :class="{ disabled: !mtsIdentifiersValid }"
            :aria-disabled="String(!mtsIdentifiersValid)"
            @click.prevent="defineModel()">
            Определить устройство
        </button>
        </br>
        </br>
        <div class="body-form__step"
        :class="{ 'body-form__step__disabled': !phoneNumberEntered }">
          <label
            class="body-form__label">
            Шаг {{ 5 + initialStepOffset }}. Выберите устройство:<br>
            <span class="body-form__label__descirption">
              Выберите производителя, модель и объем памяти устройства
            </span>
          </label>
        </div>
        </div>
        <div v-if="errorSearch" class="search-model-error" role="alert">{{ errorSearch }}</div>
          <div class="body-form__step"
          :class="{ 'body-form__step__disabled': !phoneNumberEntered }">
            <div v-if="deviceList" class="chooseModel">
              <multiselect ref="ms_manufacture" :disabled="!defineDevice" :allow-empty="false" :searchable="true"  v-model="valueManufacture" :options="deviceList.manufactures" @select="chooseManufacture" placeholder="Производитель" selectLabel="Выбрать" deselectLabel="" selectedLabel="Выбрано" ></multiselect>
              <multiselect ref="ms_model" :allow-empty="false" :searchable="true" :disabled="deviceList.models.length==0" v-model="valueModel" :options="deviceList.models" @select="chooseModel" placeholder="Модель" selectLabel="Выбрать" deselectLabel="" selectedLabel="Выбрано" ></multiselect>
              <multiselect @keyup.enter="modelId ? startSearch() : false" ref="ms_storage" :allow-empty="false" :searchable="true" :disabled="deviceList.storages.length==0" v-model="valueStorage" :options="deviceList.storages" @select="chooseStorage" placeholder="Объем памяти" selectLabel="Выбрать" deselectLabel="" selectedLabel="Выбрано" ></multiselect>
            </div>
        </div>
      </div>
      
      <!-- <more-info
        v-else
        :number="number" /> -->
      <div>
  
</div>
      <div class="popup-overlay" v-if="blockedPhonePopupVisible">
        <div class="popup-container">
          <div class="popup-header">
            <h3>Номер заблокирован</h3>
          </div>
          <div class="popup-body">
            <p>Данный номер заблокирован. Обслуживание данного клиента в рамках выкупа невозможно. Пожалуйста сообщите клиенту, что ему отказано в выкупе, так как его персональные данные не соответствуют требованиям.</p>
          </div>
          <div class="popup-footer">
            <button class="btn next" @click.prevent="closeBlockedPhonePopup">
              Понятно
            </button>
          </div>
        </div>
      </div>
      <div class="popup-overlay" v-if="buyoutCheckPopupVisible">
        <div class="popup-container">
          <div class="popup-header">
            <h3>{{ buyoutCheckPopupTitle }}</h3>
          </div>
          <div class="popup-body">
            <p>{{ buyoutCheckPopupMessage }}</p>
          </div>
          <div class="popup-footer popup-footer--spread">
            <button class="btn cancel" @click.prevent="closeBuyoutCheckPopup">
              Закрыть
            </button>
            <button
              v-if="buyoutCheckPopupMode === 'buyout_check_unavailable'"
              class="btn next error"
              @click.prevent="continueBuyoutWithRisk">
              Продолжить с риском
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="buymodal-block__footer">
      <label v-if="showPreliminaryCheckbox" class="checkbox-container" style="margin-bottom: 16px;">
        Предварительная оценка
        <input type="checkbox" v-model="preliminaryValue">
        <span class="checkmark"></span>
      </label>
      <button
        type="button"
        class="btn next"
        ref="searchButton"
        :disabled="startSearchTechnicallyDisabled"
        :class="{ disabled: !modelId || !currentIdentifiersValid || !initialSelectionReady }"
        :aria-disabled="String(!modelId || !currentIdentifiersValid || !initialSelectionReady)"
        @click.prevent="startSearch()">
        {{ usesInitialContractType ? 'Начать оценку' : 'Начать выкуп' }}
      </button>
    </div>

  </div>

</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

import MoreInfo from './MoreInfo';
import Multiselect from 'vue-multiselect'
import buyoutCheckMixin from '../buyoutCheckMixin';
import {
  IDENTIFIER_MAX_LENGTH,
  IDENTIFIER_REASONS,
  createMissingSecondImeiStatus,
  createNonNumericIdentifierStatus,
  createOptionalIdentifierStatus,
  createPossibleEidStatus,
  createTooLongIdentifierStatus,
  getInvalidIdentifierPopupMessage,
  getProjectedIdentifierValue,
  isPossibleEidAttempt,
  trackIdentifierOverflowAttempt,
  validateDeviceIdentifier,
} from '@/utils/deviceIdentifier';

export default {
  mixins: [buyoutCheckMixin],
  components: {
    MoreInfo,
    Multiselect
  },
  data() {
    return {
      moreInfo: false,
      valueManufacture: null,
      valueModel: null,
      valueStorage: null,
      valueSource: null,
      customSource: '',
      sourceOptions: [],
      sourceData: [], // Массив объектов с сервера для хранения id
      modelId: null,
      initialType: null,
      flowType: null,
      phoneNumberEntered: false,
      phoneCheckLoading: false,
      blockedPhonePopupVisible: false,
      withoutDeviceIdSecond: false,
      defineDevice: false,
      loadingSourceOptions: false,
      primaryIdentifierStatusOverride: null,
      secondIdentifierStatusOverride: null,
      identifierOverflowAttempts: {
        primary: null,
        second: null,
      },
      suppressIdentifierSubmitUntil: 0,
    }
  },
  computed: {
    ...mapState('buyphones', ['number', 'numberLength', 'errorSearch', 'deviceList', 'defineModelByIMEI','loader', 'phoneNumber','phoneNumberLength', 'deviceIdSecond', 'deviceIdSecondLength', 'preliminary']),
    ...mapState('user', ['user']),
    preliminaryValue: {
      get() {
        return this.preliminary;
      },
      set(value) {
        this.SET_PRELIMINARY(value);
      }
    },
    showPreliminaryCheckbox() {
      return this.user?.preliminaryCheckEnabled === true;
    },
    showCustomSourceInput() {
      return this.valueSource === 'Другое';
    },
    usesInitialContractType() {
      return this.flowType === 'mts' && this.user && this.user.flowType === 'mts'
        && ['buyout', 'tradein', 'both'].includes(this.user.mtsContractTypeMode);
    },
    hasInitialTypeChoice() { return this.usesInitialContractType && this.user.mtsContractTypeMode === 'both'; },
    initialStepOffset() { return this.hasInitialTypeChoice ? 1 : 0; },
    initialTypeOptions() { return ['buyout', 'tradein', 'undecided']; },
    initialContractType() {
      if (!this.usesInitialContractType) return null;
      return this.hasInitialTypeChoice ? this.initialType : this.user.mtsContractTypeMode;
    },
    initialSelectionReady() { return !this.usesInitialContractType || this.initialTypeOptions.includes(this.initialContractType); },
    canEnterPhone() { return this.sourceSelected && this.initialSelectionReady; },
    sourceSelected() {
      // Проверяем, выбран ли источник
      if (!this.valueSource) return false;
      // Если выбрано "Другое", проверяем, что введен кастомный источник
      if (this.valueSource === 'Другое') {
        return this.customSource && this.customSource.trim().length > 0;
      }
      return true;
    },
    isPrimaryIdentifierOptional() {
      return this.flowType !== 'mts' && this.flowType !== 'mvm';
    },
    primaryIdentifierStatus() {
      if (this.primaryIdentifierStatusOverride) {
        return this.primaryIdentifierStatusOverride;
      }

      if (this.isPrimaryIdentifierOptional && !String(this.number || '').trim()) {
        return createOptionalIdentifierStatus();
      }

      return validateDeviceIdentifier(this.number, {
        allowSerial: this.flowType !== 'mts',
        label: 'IMEI',
      });
    },
    secondIdentifierStatus() {
      if (this.withoutDeviceIdSecond) {
        return createMissingSecondImeiStatus();
      }

      return this.secondIdentifierStatusOverride || validateDeviceIdentifier(this.deviceIdSecond, {
        allowSerial: false,
        label: 'IMEI2',
      });
    },
    mtsIdentifiersValid() {
      return this.primaryIdentifierStatus.valid && this.secondIdentifierStatus.valid;
    },
    currentIdentifiersValid() {
      return this.flowType === 'mts'
        ? this.mtsIdentifiersValid
        : this.primaryIdentifierStatus.valid;
    },
    startSearchTechnicallyDisabled() {
      if (this.loader || this.phoneCheckLoading) {
        return true;
      }

      if (this.flowType === 'mts' && !this.phoneNumberEntered) {
        return true;
      }
      if (!this.initialSelectionReady) return true;

      return !this.modelId && this.currentIdentifiersValid;
    }
  },
  beforeMount() {
    this.setEmptyModel()
    this.getModelInfo({ imei: '', loader: false});
    this.chooseImeiInput();
    this.loadSourceOptions(); // Загружаем варианты источников
    const contractId = this.$storage.get('contractId')
    const flowType = this.$storage.get('flowType')
    this.flowType = flowType ? flowType : 'default'
    if (contractId){
      this.exsistOrder(contractId);
    }
  },
  methods: {
    initialTypeLabel(type) { return ({ buyout: 'Выкуп', tradein: 'Trade-in', undecided: 'Не определился' })[type] || ''; },
    ...mapMutations('buyphones', ['SET_NUMBER', 'SET_ERROR_SEARCH','SET_MODELS_LIST','SET_STORAGES_LIST','SET_PHONENUMBER', 'SET_DEVICEID_SECOND', 'SET_PRELIMINARY', 'SET_SKIP_INFO_MODEL', 'RESET_PHONES']),
    ...mapActions('buyphones', ['searchModel','getModelInfo','getOrderInfo','setEmptyModel', 'getReferralSources', 'checkPhoneBlocked', 'startBuyoutCheck', 'setError']),
    async chooseImeiInput(){
      setTimeout(()=>{this.$refs["inputImei"].focus()},50)
    },
    getIdentifierOverrideKey(field) {
      return field === 'second'
        ? 'secondIdentifierStatusOverride'
        : 'primaryIdentifierStatusOverride';
    },
    setIdentifierValue(field, value) {
      if (field === 'second') {
        this.SET_DEVICEID_SECOND({ number: value, length: value.length });
        return;
      }

      this.SET_NUMBER({ number: value, length: value.length });
    },
    clearIdentifierInputState(field) {
      this[this.getIdentifierOverrideKey(field)] = null;
      this.identifierOverflowAttempts[field] = null;
      this.suppressIdentifierSubmitUntil = 0;
      this.resetBuyoutCheckState();
    },
    handleIdentifierBeforeInput(event, field, digitsOnly = false) {
      if (event.inputType && event.inputType.startsWith('delete')) {
        this.clearIdentifierInputState(field);
        return;
      }

      const insertedValue = event.data || '';

      if (digitsOnly && /\D/.test(insertedValue)) {
        event.preventDefault();
        this.identifierOverflowAttempts[field] = null;
        this[this.getIdentifierOverrideKey(field)] = createNonNumericIdentifierStatus(field === 'second' ? 'IMEI2' : 'IMEI');
        return;
      }

      const projectedValue = getProjectedIdentifierValue(event.target, insertedValue);
      if (projectedValue.length > IDENTIFIER_MAX_LENGTH) {
        this.handleIdentifierOverflow(event, field, projectedValue, digitsOnly);
        return;
      }

      this.clearIdentifierInputState(field);
    },
    handleIdentifierPaste(event, field, digitsOnly = false) {
      const pastedValue = event.clipboardData?.getData('text') || '';

      if (digitsOnly && /\D/.test(pastedValue)) {
        event.preventDefault();
        this.identifierOverflowAttempts[field] = null;
        this[this.getIdentifierOverrideKey(field)] = createNonNumericIdentifierStatus(field === 'second' ? 'IMEI2' : 'IMEI');
        return;
      }

      const projectedValue = getProjectedIdentifierValue(event.target, pastedValue);
      if (projectedValue.length > IDENTIFIER_MAX_LENGTH) {
        this.handleIdentifierOverflow(event, field, projectedValue, digitsOnly);
        return;
      }

      this.clearIdentifierInputState(field);
    },
    handleIdentifierInput(event, field, digitsOnly = false) {
      const rawValue = String(event.target.value || '');

      if (rawValue.length > IDENTIFIER_MAX_LENGTH) {
        const limitedValue = (digitsOnly ? rawValue.replace(/\D/g, '') : rawValue.toUpperCase())
          .slice(0, IDENTIFIER_MAX_LENGTH);
        event.target.value = limitedValue;
        this.setIdentifierValue(field, limitedValue);
        this.handleIdentifierOverflow(event, field, rawValue, digitsOnly);
        return;
      }

      let value = rawValue.toUpperCase();
      if (digitsOnly && /\D/.test(value)) {
        value = value.replace(/\D/g, '');
        event.target.value = value;
        this[this.getIdentifierOverrideKey(field)] = createNonNumericIdentifierStatus(field === 'second' ? 'IMEI2' : 'IMEI');
      } else {
        this[this.getIdentifierOverrideKey(field)] = null;
      }

      this.suppressIdentifierSubmitUntil = 0;
      this.identifierOverflowAttempts[field] = null;
      this.setIdentifierValue(field, value);
      this.resetBuyoutCheckState();
    },
    handleIdentifierOverflow(event, field, projectedValue, digitsOnly = false) {
      event?.preventDefault();
      const attempt = trackIdentifierOverflowAttempt(
        this.identifierOverflowAttempts[field],
        event?.target?.value,
        projectedValue,
      );
      this.identifierOverflowAttempts[field] = attempt;

      if (isPossibleEidAttempt(attempt)) {
        this.rejectOversizedIdentifier(event, field);
        return;
      }

      const label = field === 'second' ? 'IMEI2' : 'IMEI';
      this[this.getIdentifierOverrideKey(field)] = createTooLongIdentifierStatus({
        allowSerial: !digitsOnly,
        label,
        length: attempt.attemptedLength,
      });
      this.suppressIdentifierSubmitUntil = 0;
      this.resetBuyoutCheckState();
    },
    rejectOversizedIdentifier(event, field) {
      event?.preventDefault();
      this.setIdentifierValue(field, '');
      this[this.getIdentifierOverrideKey(field)] = createPossibleEidStatus();
      this.identifierOverflowAttempts[field] = null;
      this.suppressIdentifierSubmitUntil = Date.now() + 350;
      this.resetBuyoutCheckState();

      if (event?.target) {
        event.target.value = '';
        event.target.blur();
      }

      this.setError({
        type: 'possibleEid',
        message: 'Вы считали не IMEI. IMEI должен содержать 15 цифр. Убедитесь, что сканируете IMEI, а не EID',
      });
    },
    handleWithoutSecondImeiChange() {
      this.secondIdentifierStatusOverride = null;
      this.identifierOverflowAttempts.second = null;
      this.suppressIdentifierSubmitUntil = 0;

      if (this.withoutDeviceIdSecond) {
        this.setIdentifierValue('second', '');
      }

      this.resetBuyoutCheckState();
    },
    showIdentifierValidationPopup(status, { allowSerial = false, label = 'IMEI' } = {}) {
      const isPossibleEid = status.reason === IDENTIFIER_REASONS.POSSIBLE_EID;
      this.setError({
        type: isPossibleEid ? 'possibleEid' : 'invalidIdentifier',
        message: isPossibleEid
          ? 'Вы считали не IMEI. IMEI должен содержать 15 цифр. Убедитесь, что сканируете IMEI, а не EID'
          : getInvalidIdentifierPopupMessage(status, { allowSerial, label }),
      });
    },
    validateIdentifiersBeforeAction() {
      if (Date.now() < this.suppressIdentifierSubmitUntil) {
        return false;
      }

      if (!this.primaryIdentifierStatus.valid) {
        this.showIdentifierValidationPopup(this.primaryIdentifierStatus, {
          allowSerial: this.flowType !== 'mts',
          label: 'IMEI',
        });
        return false;
      }

      if (this.flowType === 'mts' && !this.secondIdentifierStatus.valid) {
        this.showIdentifierValidationPopup(this.secondIdentifierStatus, {
          allowSerial: false,
          label: 'IMEI2',
        });
        return false;
      }

      return true;
    },
    handlePhoneFocus(event) {
      // Если поле пустое при фокусе, заполняем начальным значением
      if (!event.target.value || event.target.value.length < 3) {
        event.target.value = '+7 ';
        this.SET_PHONENUMBER({ phoneNumber: '+7 ', length: 3 });
      }
    },
    handlePhoneInput(event) {
      let value = event.target.value;
      
      // Если пользователь стирает и остается меньше +7, сбрасываем в пустую строку
      if (value.length < 3 || !value.startsWith('+7')) {
        value = '';
        event.target.value = '';
      }
      
      // Если поле пустое, устанавливаем начальное значение +7
      if (value === '') {
        setTimeout(() => {
          event.target.value = '+7 ';
          this.SET_PHONENUMBER({ phoneNumber: '+7 ', length: 3 });
        }, 0);
        return;
      }
      
      this.SET_PHONENUMBER({ 
        phoneNumber: value, 
        length: value.length 
      });
    },
    phoneNumberMask(value) {
      // Всегда возвращаем маску для российского номера +7
      return ['+', '7', ' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
    },
    async exsistOrder(contractId){
      this.SET_ERROR_SEARCH();
      await this.getOrderInfo({ 
        contractId: contractId
      });
    },
    getSearchPayload() {
      let sourceInfo;
      let sourceId;

      if (this.valueSource === 'Другое') {
        sourceInfo = this.customSource;
        sourceId = null;
      } else {
        sourceInfo = this.valueSource;
        const selectedData = this.sourceData.find(item => item.name === this.valueSource);
        sourceId = selectedData?.id || null;
      }

      const payload = {
        imei: this.number,
        imei2: this.withoutDeviceIdSecond ? null : this.deviceIdSecond,
        phoneNumber: this.phoneNumber,
        modelId: this.modelId,
        extOrderId: this.$storage.get('extOrderId'),
        defineModelId: this.defineModelByIMEI ? this.defineModelByIMEI.modelId : null,
        sourceInfo,
        sourceId,
        data: this.$storage.get('order-data') || {}
      };
      if (this.usesInitialContractType) payload.initialContractType = this.initialContractType;
      return payload;
    },
    resetBuyoutFlow() {
      this.RESET_PHONES();
      this.closeBuyoutCheckPopup();
      this.blockedPhonePopupVisible = false;
      this.valueManufacture = null;
      this.valueModel = null;
      this.valueStorage = null;
      this.valueSource = null;
      this.customSource = '';
      this.modelId = null;
      this.initialType = null;
      this.phoneNumberEntered = false;
      this.phoneCheckLoading = false;
      this.resetBuyoutCheckState();
      this.withoutDeviceIdSecond = false;
      this.defineDevice = false;
      this.primaryIdentifierStatusOverride = null;
      this.secondIdentifierStatusOverride = null;
      this.identifierOverflowAttempts.primary = null;
      this.identifierOverflowAttempts.second = null;
      this.suppressIdentifierSubmitUntil = 0;
      this.$nextTick(() => {
        this.chooseImeiInput();
      });
    },
    async executeSearchModel() {
      if (!this.initialSelectionReady || !this.validateIdentifiersBeforeAction() || !this.modelId) {
        return null;
      }

      const response = await this.searchModel(this.getSearchPayload());

      if (this.flowType === 'mts' && (!response || response.ErrorDetails || response.error)) {
        this.SET_SKIP_INFO_MODEL(false);
      }

      return response;
    },
    async continueBuyoutWithRisk() {
      this.markBuyoutCheckPassed(this.number);
      await this.executeDefineModel();
    },
    async startSearch() {
      if (!this.initialSelectionReady) return;
      if (!this.validateIdentifiersBeforeAction()) {
        return;
      }

      if (!this.modelId) {
        return;
      }

      this.SET_ERROR_SEARCH();
      if (this.flowType === 'mts') {
        this.SET_SKIP_INFO_MODEL(true);
      }
      await this.executeSearchModel();
    },
    async chooseManufacture(selectedOptions) {
      this.SET_MODELS_LIST(Object.keys(this.deviceList.data[selectedOptions]))
      this.SET_STORAGES_LIST([])
      this.modelId = null
      this.valueStorage = null
      this.valueModel = null
      setTimeout(()=>{this.$refs["ms_model"].activate()},50)
      
    },
    async chooseModel(selectedOptions) {
      this.SET_STORAGES_LIST(Object.keys(this.deviceList.data[this.valueManufacture][selectedOptions]))
      this.modelId = null
      this.valueStorage = null
      setTimeout(()=>{this.$refs["ms_storage"].activate()},50)
    },
    async chooseSource(selectedOption) {
      // Если выбрано "Другое", фокусируемся на поле ввода
      if (selectedOption === 'Другое') {
        setTimeout(() => {
          this.$refs["inputCustomSource"]?.focus();
        }, 50);
      } else {
        this.customSource = '';
      }
      
      // Логируем выбранный источник
      const selectedData = this.sourceData.find(item => item.name === selectedOption);
      console.log('Выбран источник:', selectedOption, 'ID:', selectedData?.id);
    },
    async loadSourceOptions() {
      this.loadingSourceOptions = true;
      try {
        const response = await this.getReferralSources();
        if (response && Array.isArray(response)) {
          // Сохраняем полные данные для получения id
          this.sourceData = response;
          
          // Извлекаем только названия для отображения в multiselect
          this.sourceOptions = response.map(item => item.name);
          
          // Добавляем "Другое" если его нет в списке
          const hasOther = response.some(item => item.name === 'Другое');
          if (!hasOther) {
            this.sourceOptions.push('Другое');
            // Добавляем в sourceData тоже для консистентности
            this.sourceData.push({ id: null, name: 'Другое' });
          }
        } else {
          console.warn('Неожиданный формат данных от API referral-sources');
          this.setFallbackOptions();
        }
      } catch (error) {
        console.error('Ошибка загрузки источников:', error);
        console.log('Используются стандартные варианты источников');
        this.setFallbackOptions();
      } finally {
        this.loadingSourceOptions = false;
      }
    },
    setFallbackOptions() {
      // Заглушка на случай ошибки API
      this.sourceOptions = [
        'Реклама в интернете',
        'Социальные сети',
        'Рекомендация друзей',
        'Реклама на телевидении',
        'Печатная реклама',
        'SMS-рассылка',
        'Сотрудник магазина',
        'Другое'
      ];
      // Создаем соответствующие объекты для sourceData
      this.sourceData = this.sourceOptions.map((name, index) => ({
        id: name === 'Другое' ? null : index + 1,
        name: name
      }));
    },
    async chooseStorage(selectedOptions) {
      this.modelId = this.deviceList.data[this.valueManufacture][this.valueModel][selectedOptions].id
      setTimeout(()=>{this.$refs["searchButton"].focus()},50)
    },
    async confirmPhoneNumber() {
      if (!this.canEnterPhone || this.phoneNumberLength !== 18 || this.phoneCheckLoading) {
        return;
      }

      this.phoneCheckLoading = true;
      try {
        const response = await this.checkPhoneBlocked({ phoneNumber: this.phoneNumber });
        if (response && response.blocked === true) {
          this.blockedPhonePopupVisible = true;
          return;
        }
        this.phoneNumberEntered = true;
      } catch (error) {
        console.error('Ошибка проверки телефона:', error);
        this.phoneNumberEntered = true;
      } finally {
        this.phoneCheckLoading = false;
      }
    },
    closeBlockedPhonePopup() {
      this.blockedPhonePopupVisible = false;
    },
    async executeDefineModel() {
      if (!this.validateIdentifiersBeforeAction()) {
        return;
      }

      await this.getModelInfo({
        imei: this.number,
        imei2: this.withoutDeviceIdSecond ? null : this.deviceIdSecond,
        loader: true,
      });
      if (this.defineModelByIMEI){
        this.valueManufacture = this.defineModelByIMEI.manufacture;
        this.valueModel = this.defineModelByIMEI.model;
        setTimeout(()=>{this.$refs["ms_storage"].activate()},50)
      }else{
        setTimeout(()=>{this.$refs["ms_manufacture"].activate()},50)
      }
      this.defineDevice = true
    },
    async defineModel(){
      if (!this.validateIdentifiersBeforeAction()) {
        return;
      }

      this.SET_ERROR_SEARCH();
      const canContinue = await this.ensureBuyoutCheckPassed(this.number);

      if (canContinue) {
        await this.executeDefineModel();
      }
    },
    onBuyoutCheckError(message) {
      this.SET_ERROR_SEARCH(message);
    },
    async gotosign(){
      // this.$emit('changeScreen', {type: 'next', id: 0})
      this.$emit('gotosign')
    }
  },
}
</script>

<style scoped>
.search-model-error {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  margin: 12px 0;
  overflow-wrap: anywhere;
  color: #cf4848;
  font-size: 14px;
  line-height: 20px;
}
</style>
